goog.provide("shadow.js.shim.module$react_bootstrap$Modal$default");
shadow.js.shim.module$react_bootstrap$Modal$default = shadow.js.require(90, {})["default"];
